import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';
import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils';

const cardVariants = cva('rounded border border-border bg-surface p-6', {
  variants: {
    elevation: {
      primary: 'shadow-card-primary',
      secondary: 'shadow-card-secondary',
    },
  },
  defaultVariants: {
    elevation: 'secondary',
  },
});

interface CardProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof cardVariants> {
  header?: ReactNode;
  footer?: ReactNode;
}

export function Card({ children, className, elevation, footer, header, ...props }: CardProps) {
  return (
    <section className={cn(cardVariants({ elevation }), className)} {...props}>
      {header ? <div className="mb-4 border-b border-border pb-3">{header}</div> : null}
      {children}
      {footer ? <div className="mt-4 border-t border-border pt-3">{footer}</div> : null}
    </section>
  );
}
